// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  float: left;
  width: 100%;
  padding: 55px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1100px) {
    padding-top: ${scale(1100, 767, 55, 22, "vw")};
    padding-bottom: ${scale(1100, 767, 55, 33, "vw")};
  }
  @media (max-width: 700px) {
    margin: 35px 23px 23px 23px;
    width: calc(100% - 46px);
    padding: 0;
    flex-direction: column;
  }
`;
const Image = styled.div`
  width: 470px;
  height: auto;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 470, 310)};
  }
  @media (max-width: 700px) {
    width: 100%;
    order: 1;
  }
`;
const ImageSizer = styled.div`
  width: 100%;
  float: left;
  height: 0;
  padding-top: 100%;
`;
const Article = styled.div`
  width: 469px;
  padding-right: 100px;
  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 469, 351)};
    padding-right: ${scale(1100, 767, 100, 20)};
  }
  @media (max-width: 700px) {
    width: 100%;
    order: 2;
    padding: 0;
  }
`;
const Title = styled.div`
  width: 100%;
  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  color: #3949ab;
  float: left;
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 42, 31, "vw")};

    line-height: 1.23;
    letter-spacing: 0.4px;
  }
  @media (max-width: 700px) {
    width: 100%;
    font-size: 23px;
    line-height: 1.35;
    letter-spacing: 0.3px;
    text-align: center;
    padding: 30px 0 10px 0;
  }
`;
const Body = styled.div`
  padding-top: 17px;
  width: 100%;
  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.85);
  float: left;
  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 14, "vw")};

    line-height: 1.57;
    letter-spacing: 1px;
  }
  @media (max-width: 700px) {
    width: 100%;
    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.8px;
    text-align: center;
    padding: 0;
    float: none;
  }
`;

class ArticleWhite extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <Article>
          <Title>{this.title()}</Title>
          <Body>{this.body()}</Body>
        </Article>
        <Image style={this.image()}>
          <ImageSizer />
        </Image>
      </Wrapper>
    );
  }
}

export default ArticleWhite;



// WEBPACK FOOTER //
// ./src/components/ArticleWhite.js